import { useEffect, useState } from "react";
import { trackingApi } from "api";
import type { SelectOption } from "components/ui/Select";
import { createCarrierIconUrl } from "utils/url.utils";

const carrierIcon = (code: string) => (
  <img
    className="pcline"
    src={createCarrierIconUrl(code)}
    alt={`${code} logo`}
    width={20}
    height={20}
    loading="lazy"
    onError={(event) => event.currentTarget.classList.add("is-missing")}
  />
);

export const useCarriers = (enabled: boolean): { options: SelectOption[] } => {
  const [options, setOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    if (!enabled || options.length > 0) return;

    let cancelled = false;

    trackingApi
      .carriers()
      .then(({ data }) => {
        if (cancelled) return;

        setOptions(
          data.carriers
            .filter((carrier) => carrier.status.is_active)
            .map((carrier) => ({ value: carrier.code, label: carrier.name, icon: carrierIcon(carrier.code) }))
            .sort((a, b) => a.label.localeCompare(b.label))
        );
      })
      .catch(() => {
        // Leaves the picker on "Detect automatically", which still works.
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, options.length]);

  return { options };
};
